import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPhoneAlt, FaEnvelope, FaWhatsapp, FaTimes } from 'react-icons/fa';

const E = [0.16, 1, 0.3, 1];

const StickyMobileCTA = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden pointer-events-none">
      <AnimatePresence>
        {isExpanded && (
          <div className="mx-6 mb-6 pointer-events-auto">
            <motion.div
              initial={{ opacity: 0, y: 40, scale: 0.98 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 40, scale: 0.98 }}
              transition={{ duration: 0.3, ease: E }}
              className="bg-white border border-[#EAECE9] shadow-[0_24px_50px_rgba(0,0,0,0.18)] p-6 rounded-[28px] max-w-md mx-auto"
            >
              <div className="flex items-center justify-between mb-5">
                <h3 className="text-base font-bold text-[#1D1D1F] tracking-tight">Get in Touch</h3>
                <button
                  onClick={() => setIsExpanded(false)}
                  className="w-7 h-7 rounded-full bg-[#FAFBF9] border border-[#EAECE9] flex items-center justify-center text-gray-500 hover:text-black hover:border-black transition-colors"
                >
                  <FaTimes size={11} />
                </button>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <a
                  href="tel:+919164752256"
                  className="flex items-center justify-center gap-2 bg-[#FAFBF9] border border-[#EAECE9] text-[#1C2E1E] px-4 py-3 rounded-2xl text-xs font-semibold hover:border-black transition-colors"
                >
                  <FaPhoneAlt size={10} />
                  Call Us
                </a>
                <a
                  href="mailto:contact@cyborgsapient.com"
                  className="flex items-center justify-center gap-2 bg-[#FAFBF9] border border-[#EAECE9] text-[#1C2E1E] px-4 py-3 rounded-2xl text-xs font-semibold hover:border-black transition-colors"
                >
                  <FaEnvelope size={10} />
                  Email Us
                </a>
                <a
                  href="https://wa.me/919164752256"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 bg-[#FAFBF9] border border-[#EAECE9] text-[#1C2E1E] px-4 py-3 rounded-2xl text-xs font-semibold hover:border-black transition-colors"
                >
                  <FaWhatsapp size={12} />
                  WhatsApp
                </a>
                <Link
                  to="/contact"
                  onClick={() => setIsExpanded(false)}
                  className="flex items-center justify-center gap-2 text-white px-4 py-3 rounded-2xl text-xs font-semibold hover:opacity-90 transition-opacity"
                  style={{ background: 'linear-gradient(120deg, #FF7332 0%, #FF1E90 55%, #7000FF 100%)' }}
                >
                  Inquire Now
                </Link>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
      
      {!isExpanded && (
        <div className="mx-6 mb-6 pointer-events-auto">
          <div className="bg-white/90 backdrop-blur-md border border-[#EAECE9] p-2.5 rounded-full shadow-[0_16px_40px_rgba(0,0,0,0.12)] max-w-md mx-auto flex items-center justify-between">
            {/* Get Started Button - Brand Gradient Pill */}
            <Link
              to="/contact"
              className="flex-1 text-center text-xs font-semibold text-white py-3 rounded-full tracking-wide shadow-sm hover:opacity-95 transition-opacity"
              style={{ background: 'linear-gradient(120deg, #FF7332 0%, #FF1E90 55%, #7000FF 100%)' }}
            >
              Get Started
            </Link>
            
            {/* Divider */}
            <div className="w-px h-6 bg-[#EAECE9] mx-3" />
            
            {/* Contact Button */}
            <button
              onClick={() => setIsExpanded(true)}
              className="flex items-center gap-2 px-5 py-3 bg-[#1C2E1E] text-white rounded-full hover:bg-black transition-colors text-xs font-semibold"
            >
              <FaPhoneAlt size={10} />
              Contact
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StickyMobileCTA;
